webpackJsonp([91633610366748],{

/***/ 755:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(7);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _config = __webpack_require__(8);
	
	var _FleetBreadcrum = __webpack_require__(31);
	
	var _FleetBreadcrum2 = _interopRequireDefault(_FleetBreadcrum);
	
	var _Fleet = __webpack_require__(20);
	
	var _Fleet2 = _interopRequireDefault(_Fleet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//Components
	var StandardSuvEs = function StandardSuvEs(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'page  Standard Suv' },
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: ' Standard Suv Vehicles for Rent | Budget Nicaragua',
	      meta: [{
	        name: 'description',
	        content: 'Frequently Asked Questions about car rentals. '
	      }],
	      link: [{
	        rel: 'alternate',
	        hreflang: 'es',
	        href: './en/fleet/standard_suv'
	      }]
	    }),
	    _react2.default.createElement(_FleetBreadcrum2.default, {
	      lang: props.pathContext.langKey,
	      currentPage: ' Standard Suv Cars'
	    }),
	    _react2.default.createElement(
	      'h1',
	      null,
	      ' Standard Suv'
	    ),
	    _react2.default.createElement(_Fleet2.default, {
	      lang: props.pathContext.langKey,
	      types: props.data.dataJson.fleetTypes,
	      fleet: props.data.dataJson.fleet,
	      features: props.data.dataJson.fleetFeatures,
	      category: 1
	    })
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = StandardSuvEs;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-fleet-standard-suv-es-js-b08cbd08ded1484c16ea.js